var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#626362;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.9,61.3l-87.3-28c-1.5-0.5-3.1-0.5-4.6,0L4.8,59.4c-2.9,1-4.8,3.7-4.8,6.7c0,3.1,1.9,5.7,4.8,6.7l30.8,11.3 l0.4,37.2c0,1.8,0.7,3.4,1.8,4.7c14.5,16,30.8,21,52.5,21c21.4,0,35.7-7.1,50.4-22.7c1.2-1.3,1.9-3.1,1.9-4.8l-1-36.7l23-8.2 l-0.1,21.5c-1.7,1.3-1.8,3.4-1.8,5.6v17.3c0,3.9,0.7,7.7,4.6,7.7c3.9,0,4.5-3.6,4.5-7.5v-15.8c0-1.6,0.2-6-1.2-7.2l-0.2-23l4.7-2 c2.9-1,4.4-1.6,4.7-4.3C180.3,64,178.8,62.2,175.9,61.3 M133.2,119.7c-11.7,11.4-27.2,17.7-43.6,17.7c-16.8,0-32.8-5-44.6-16.8 l0.2-33l39,12.4c0.8,0.2,1.5,0.4,2.3,0.4c0.8,0,1.5-0.2,2.3-0.4l43.9-14.3L133.2,119.7z M86.5,91.8L11.6,65l74.8-25.5l79.5,25.9 L86.5,91.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.ea3fa24da0c460679d424de2389a704e.svg";
export { ForwardRef as ReactComponent };